import { render, staticRenderFns } from "./DGOContainer.vue?vue&type=template&id=fea900c2&"
import script from "./DGOContainer.js?vue&type=script&lang=js&"
export * from "./DGOContainer.js?vue&type=script&lang=js&"
import style0 from "./DGOContainer.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports